import { render } from "./TableNormal.vue?vue&type=template&id=4851db1c&scoped=true"
import script from "./TableNormal.vue?vue&type=script&lang=js"
export * from "./TableNormal.vue?vue&type=script&lang=js"

import "./TableNormal.vue?vue&type=style&index=0&id=4851db1c&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4851db1c"]])

export default __exports__